import moment from 'moment'

const typeLabels = {
  PROJECT: 'Ordinario',
  ADM: 'ADM'
}

const statusLabels = {
  PENDING_FIRST_VALIDATION: 'Pendiente 1ª Validación',
  PENDING_SECOND_VALIDATION: 'Pendiente 2ª Validación',
  CONFIRMATED: 'Confirmado'
}

const mealCostTypeLabels = {
  FULL: 'Completa',
  HALF: 'Media',
  NONE: 'Ninguna'
}

const WorkOrder = function(data) {
  Object.assign(this, data)
  this.typeLabel = typeLabels[this.workOrderType]
  this.statusLabel = statusLabels[this.validationStatus]
  this.mealCostTypeLabel = mealCostTypeLabels[this.mealCostType]
  this.workOrderDate = this.workOrderDate && moment(this.workOrderDate).format('YYYY-MM-DD')
}

export default WorkOrder



// WEBPACK FOOTER //
// ./src/api/models/workOrder.js